/**
 * api接口的统一出口
 */
import topics from '@/api/topics';
import user from '@/api/user';
// 其他模块的接口……

// 导出接口
export default {
  topics,
  user,
  // ……
};
